import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { CommonValues } from '../../classes/common-values';
import { DataService } from '../../services/data/data.service';

@Component({
  selector: 'nsc-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss']
})
export class PageTitleComponent implements OnChanges, OnInit {
  @Input('route') route: string;

  content = {
    appTitle: 'National Student Clearinghouse Transcript Services',
    pageTitle: null,
    recipient: null
  };

  constructor(
    private commonValues: CommonValues,
    private dataService: DataService,
    private title: Title
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    this.setPageTitleConfig(this.route);
  }

  // set the content to display based on the current route;
  setPageTitleConfig(route: string): void {
    switch (route) {
      case this.commonValues.routes.requestorIdentification:
      case this.commonValues.routes.requestorAddress:
      case this.commonValues.routes.requestorAttend:
        this.content.pageTitle = 'Enter Personal Information';
        this.content.recipient = null;
        break;

      case this.commonValues.routes.recipientSelect:
        this.content.pageTitle = 'Select Transcript and Delivery Details';
        this.content.recipient = null;
        break;

      case this.commonValues.routes.recipientDeliveryMethod:
        this.content.pageTitle = 'Select Transcript and Delivery Details';
        this.content.recipient = this.dataService.getRecipient();
        break;

      case this.commonValues.routes.recipientAddress:
      case this.commonValues.routes.recipientEmail:
        this.content.pageTitle = 'Provide Delivery Information';
        this.content.recipient = this.dataService.getRecipient();
        break;

      case this.commonValues.routes.orderReview:
      case this.commonValues.routes.orderConsent:
      case this.commonValues.routes.orderPayment:
        this.content.pageTitle = 'Checkout';
        this.content.recipient = null;
        break;

      case this.commonValues.routes.orderConfirmation:
        this.content.pageTitle = 'Order Confirmation';
        this.content.recipient = null;
        break;

      default:
        this.content.pageTitle = null;
        this.content.recipient = null;
        break;
    }

    // change the TITLE tag based on the route;
    const newTitle = this.content.pageTitle
      ? `${this.content.pageTitle} · ${this.content.appTitle}`
      : this.content.appTitle;

    this.title.setTitle(newTitle);
  }
}
